// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1010":"565a8eab","1142":"3ba4795d","1440":"fd828da0","5692":"af5c2dfb","6626":"565a8eab"}[chunkId] + ".chunk.css";
};